import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { config } from '../../shared/smartadmin.config';
import { Observable } from 'rxjs/Observable';
import { Console } from '@angular/core/src/console';

@Injectable()
export class PresupuestoApiService {
  data: any[] = [];

  presupuestoURL: string = config.API_DATA_URL + "/presupuesto";

  constructor(public http: HttpClient) {}

  public getPresupuestoData(idOS): Observable<any> {
    const headers = this.getHeaders();

    return this.http
      .get(this.presupuestoURL + "/GetPresupuesto/" + idOS, { headers })
      .map((response: any) => {
        this.data = response;
        return this.data;
      })
      .catch(this.handleError);
  }

  public getAutorizacionData(idOS): Observable<any> {
    const headers = this.getHeaders();

    return this.http
      .get(this.presupuestoURL + "/GetAutorizacion/" + idOS, { headers })
      .map((response: any) => {
        this.data = response;
        return this.data;
      })
      .catch(this.handleError);
  }

  public getComplemento(idOS: number): Observable<any> {
    const headers = this.getHeaders();

    return this.http
      .get(this.presupuestoURL + "/GetComplemento/" + idOS, { headers })
      .map((response: any) => {
        this.data = response;
        return this.data;
      })
      .catch(this.handleError);
  }

  public getPlanTrabajoData(idOS): Observable<any> {
    const headers = this.getHeaders();

    return this.http
      .get(this.presupuestoURL + "/GetPlanTrabajo/" + idOS, { headers })
      .map((response: any) => {
        this.data = response;
        return this.data;
      })
      .catch(this.handleError);
  }

  public AgregarDetalle(presupuesto: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(presupuesto);
    return this.http
      .post(this.presupuestoURL + "/AgregarDetalle", param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public ActualizarManoObra(presupuesto: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(presupuesto);
    return this.http
      .post(this.presupuestoURL + "/ActualizarManoObra", param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public ActualizarComentario(comentario: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(comentario);
    return this.http
      .post(this.presupuestoURL + "/ActualizarComentario", param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public AgregarComplemento(complemento: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(complemento);
    return this.http
      .post(this.presupuestoURL + "/AgregarComplemento", param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public ActualizarAutorizacion(detalle: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(detalle);
    return this.http
      .post(this.presupuestoURL + "/ActualizarAutorizacion", param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public SurteSeguro(detalle: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(detalle);
    return this.http
      .post(this.presupuestoURL + "/SurteSeguro", param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public getFechaPromesaRegistradas(idOS: number): Observable<any> {
    const headers = this.getHeaders();

    return this.http
      .get(this.presupuestoURL + "/GetFechaPromesas/" + idOS, { headers })
      .map((response: any) => {
        this.data = response;
        return this.data;
      })
      .catch(this.handleError);
  }

  public ReprogramarFechaPromesa(reprogramar: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(reprogramar);
    return this.http
      .post(this.presupuestoURL + "/ReprogramarFechaPromesa", param, {
        headers,
      })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public EliminarFechaPromesa(idOrdenServicioFechaPromesa: number, idEmpleado: number) {
    const headers = this.getHeaders();
    
    return this.http
      .delete(
        this.presupuestoURL +
          "/EliminarFechaPromesa/" +
          idOrdenServicioFechaPromesa +
          "?idEmpleado=" +
          idEmpleado,
        { headers },
      )
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public PerdidaTotal(perdida: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(perdida);
    return this.http
      .post(this.presupuestoURL + "/PerdidaTotal", param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public QuitarPerdidaTotal(perdida: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(perdida);
    return this.http
      .post(this.presupuestoURL + "/QuitarPerdidaTotal", param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public CancelarOrdenServicio(cancelar: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(cancelar);
    return this.http
      .post(this.presupuestoURL + "/CancelarOrdenServicio", param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public QuitarCancelacion(idOrdenServicio: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(idOrdenServicio);
    return this.http
      .post(this.presupuestoURL + "/QuitarCancelacion", param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public Autorizado(detalle: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(detalle);
    return this.http
      .post(this.presupuestoURL + "/Autorizado", param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public ActualizarPlanTrabajo(detalle: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(detalle);
    return this.http
      .post(this.presupuestoURL + "/ActualizarPlanTrabajo", param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public ExportarPlan(idOS: number) {
    const headers = this.getHeaders();
    //const param = JSON.stringify(id);
    return this.http
      .get(this.presupuestoURL + "/ExportarPlanTrabajo/" + idOS, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public AceptarPresupuesto(id: number) {
    const headers = this.getHeaders();
    //const param = JSON.stringify(id);
    return this.http
      .post(this.presupuestoURL + "/AceptarPresupuesto/" + id, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public AutorizarPresupuesto(autorizar: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(autorizar);
    return this.http
      .post(this.presupuestoURL + "/AutorizarPresupuesto", param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public AutorizarPlanTrabajo(id: number, idEmpleado: number) {
    const headers = this.getHeaders();
    //const param = JSON.stringify(id);
    return this.http
      .post(
        this.presupuestoURL + "/AutorizarPlanTrabajo/" + id + "/" + idEmpleado,
        { headers },
      )
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public ComentarioPlanTrabajo(comentario: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(comentario);
    return this.http
      .post(this.presupuestoURL + "/ComentarioPlanTrabajo", param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  private getBaseUrl() {
    return (
      location.protocol +
      "//" +
      location.hostname +
      (location.port ? ":" + location.port : "") +
      "/"
    );
  }

  private getHeaders(): HttpHeaders {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
    });

    return headers;
  }

  private handleError(error: any) {
    // In a real world app, we might use a remote logging infrastructure
    // We'd also dig deeper into the error to get a better message
    const errMsg = error.message
      ? error.message
      : error.status
        ? `${error.status} - ${error.statusText}`
        : "Server error";
    console.error(errMsg); // log to console instead
    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/api/presupuesto-api.service.ts